export type PublicationWithSectionsKeyParams = {
  publicationId: string;
  entityId: number;
};

export type SaveCustomCssMutationKeyParams = {
  publicationId: string;
};

export const publicationCustomCssQueryKeys = {
  all: ['publicationCustomCss'] as const,

  publicationWithSections: (params: PublicationWithSectionsKeyParams) =>
    [...publicationCustomCssQueryKeys.all, 'publicationWithSections', params] as const,

  storyWithContent: (storyId: string) =>
    [...publicationCustomCssQueryKeys.all, 'storyWithContent', storyId] as const,

  saveCss: (params: SaveCustomCssMutationKeyParams) =>
    [...publicationCustomCssQueryKeys.all, 'saveCss', params] as const
} as const;
